abstract class ModalSelectGridBinder extends GridBinder {
    modalSelectHiddenFieldName: string;
    modalSelectButtonEmptyText: string;
    applyModalSelectUrl: string;

    //#region Modal Select Elements
    modalSelect!: JQuery<HTMLElement>;
    modalSelectOpenedYet!: JQuery<HTMLElement>;
    btnOpenModalSelect!: JQuery<HTMLElement>;
    btnClearModalSelectValue!: JQuery<HTMLElement>;
    modalSelectHiddenField!: JQuery<HTMLElement>;
    //#endregion Modal Select Elements

    constructor(
        $parent: JQuery<HTMLElement>,
        controller: string,
        modalSelectHiddenFieldName: string,
        modalSelectButtonEmptyText: string,
        options?: Partial<GridBinderOptions>
    ) {
        super({
            $parent,
            controller,
            searchUrl: "SearchModalSelect",
            bindAdditionalGridButtons: () => {
                this.$parent.findInGrid('div[name="_grid"] button[name="btnSelect"]').on('click', (event) => this.applyModalSelect(event.currentTarget as HTMLElement));
            },
            ...options // 👈 THIS IS IMPORTANT
        });

        //Set Defaults for fall back
        this.applyModalSelectUrl = 'ApplyModalSelect';

        this.modalSelectHiddenFieldName = modalSelectHiddenFieldName;
        this.modalSelectButtonEmptyText = modalSelectButtonEmptyText;
    }

    abstract loadModalSelect(event: any, data: any): void;

    //#region Modal Grid Select Specific Functions
    bindModalSelect(): void {
        this.modalSelect = this.$parent.findInGrid('.modalSelect');
        this.modalSelectOpenedYet = this.$parent.findInGrid('input[name="ModalOpenedYet"]');
        this.btnOpenModalSelect = this.$parent.findInGrid('button[name="btnOpenModal"]');
        this.btnClearModalSelectValue = this.$parent.findInGrid('button[name="btnClearValue"]');

        this.modalSelectHiddenField = this.$parent.closest('.row').findInGrid(`input[name="${this.modalSelectHiddenFieldName}"]`);

        this.btnOpenModalSelect.on('click', (event: any) =>
            this.openModalSelect(event.currentTarget as HTMLElement)
        );

        this.btnClearModalSelectValue.on('click', (event: any) =>
            this.clearModalSelectValue(event.currentTarget as HTMLElement)
        );
    }

    openModalSelect(element: HTMLElement): void {
        this.modalSelect.modal('show');

        if (this.modalSelectOpenedYet.val() === 'false') {
            this.modalSelectOpenedYet.val('true');
            this.btnSearch.click();
        }
    }

    clearModalSelectValue(element: HTMLElement): void {
        this.modalSelectHiddenField.val('');
        this.btnOpenModalSelect.text(this.modalSelectButtonEmptyText);
        this.modalSelect.modal('hide');
    }

    applyModalSelect(element: HTMLElement): void {
        const model = this.getModalSelectData(element);

        $.ajax({
            type: 'POST',
            url: `${window.appRoot}${this.controller}/${this.applyModalSelectUrl}`,
            data: model,
            success: (data: any) => {
                this.loadModalSelect(element, data);
            },
            error: (_xhr, _status, error) => {
                console.log(error);
            }
        });
    }

    getModalSelectData(element: HTMLElement): any {
        return {
            id: $(element).val() ?? '',
        };
    }
    //#endregion Modal Grid Select Specific Functions
}